module.exports = __webpack_public_path__ + "img/sv3.04326f3a.png";